import { Card, CardContent, Grid, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import {
    useForm
} from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { bindDropDown, callAPI, dateFormat, getLocalValue, IsSmallScreen, LoacalVariables, Method } from "../../../../commonFunctions/CommonFunctions";
import WSAutocompleteField from "../../../../Components/AutoComplete/AutoComplete";
import WSSCheckBoxField from "../../../../Components/CheckBox/WSCheckBox";
import WSDateField from "../../../../Components/DateField/WSDateField";
import { HeaderList, IHeaderListActions } from "../../../../Components/Header/HeaderList";
import WSHiddenField from "../../../../Components/HiddenField/WSHiddenField";
import WSSelectField from "../../../../Components/Select/WSSelect";
import { useSnackbar } from "../../../../Components/Snackbar/SnackBarContext";
import WSTextField from "../../../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../../../Components/WSTextArea/WSTextArea";
import WSTimePicker from "../../../../Components/WSTimePicker/WSTimePicker";
import config from "../../../../Config/clientConfig.json";
import { ITask } from "../../../DTO/Dto";
export const CreateTask: React.FC<any> = (props) => {
    const [leadData, setLeadData] = useState([]);
    const [loading, setLoading] = useState(false);
    const { control, register, handleSubmit, setValue, reset } = useForm();
    const { id } = useParams()
    const [loadingSaveAndNew, setLoadingSaveAndNew] = useState(false)
    const { showMessage } = useSnackbar();
    const navigate = useNavigate();
    const [activityDate, setActivityDate] = useState<any>(undefined);

    const [isReminder, setIsReminder] = useState(false);
    const isMobile = IsSmallScreen()
    const dispatch = useDispatch()
    useEffect(() => {
        return () => {
            reset();
        };
    }, []);
     useEffect(() => {
            try {
                async function getLeads() {
                    const response: any = await bindDropDown('leads', 'firstName', 'id', Method.GET, ['firstName', 'lasttName'], { field: 'leadType', value: 0 })
                    setLeadData(response)
                }
                getLeads()
            }
            catch (e) {
            }
        }, [])
    useEffect(() => {

        const getTask = async () => {
            try {

                const response: any = await callAPI(`tasks`, Method.GET, null, id);
                if (response.data) {
                    const taskData: any = response.data
                    setValue('taskName', taskData?.taskName)
                    setValue('activityDate', taskData?.activityDate)
                    setValue('activityTime', taskData?.activityTime)
                    setValue('reminder', taskData?.reminder)
                    setValue('customReminderTime', taskData?.customReminderTime)
                    setValue('leadId', taskData?.leadId)
                    setValue('taskType', taskData?.taskType)
                    setValue('priority', taskData?.priority)
                    setValue('queue', taskData?.queue)
                    setValue('customDate', dateFormat(taskData?.customDate, 'DD-MM-YYYY'))
                    setValue('notes', taskData?.notes)
                    setValue('reminderSent', taskData?.reminderSent)
                    setValue('assignedToUserId', taskData?.assignedToUserId)
                }
            }
            catch (e) {
            }
        }
        if (id) {
            getTask();
        }
    }, [id])
    const handleActivityChange = (evt: any) => {
        if (evt.target.value !== 'custom') {
            let date = dayjs();
            const val = evt.target.value === 1 ? 0 : evt.target.value === 2 ? 1 : evt.target.value
            date = date.add(Number(val), 'days'); // Assuming value is number of days
            setActivityDate(date.toISOString()); // Converts to ISO 8601 format
        } else {

            setActivityDate(evt.target.value);
        }
    };
    const handleIsReminderSend = (evt: any) => {
        setIsReminder(evt?.target?.checked)
    }
    const source = {
        url: "auth/search",
        page: 1,
        pageSize: 10000000,
        filter: [],
        sort: [],
    };
    const transFormData = (data: any) => {

        const users: Array<any> = []
        data.map((item: any) => {
            users.push({ value: item.id, label: `${item.firstName} ${item.lastName || ""}` })
        })
        return users
    }
    const handleDataSaveAndNew = async (data: any) => {
        try {
            setLoadingSaveAndNew(true)
            const response: any = await saveData(data);
            if (response && response?.message) {

                showMessage(response.message, response.success === true ? 'success' : 'error')
                if (response.success === true) {
                    reset()
                }
            } else if (response?.id) {
                reset()
                showMessage('Deals Created Successfully', 'success')
            }
        } catch (e: any) {
            showMessage(e.error);

        }
        finally {
            setLoadingSaveAndNew(false)
        }
    }
    const handleData = async (data: any) => {
        try {
            setLoading(true)
            const response: any = await saveData(data);
            if (response && response?.message) {
                showMessage(response.message, response.success === true ? 'success' : 'error')
                if (response.success === true) {
                    navigate(`/task/list`)
                }
            } else if (response?.id) {
                showMessage('Task Created Successfully', 'success')
                navigate(`/task/list`)
            }
        } catch (e: any) {
            showMessage(e.error);

        }
        finally {
            setLoading(false)
        }
    }
    const saveData = async (data: ITask) => {
        const isoString: any =  dayjs(`${data?.customDate} 00:00`, "DD-MM-YYYY HH:mm").toISOString();
        const request: ITask = {
            taskName: data?.taskName || "",
            activityDate: data?.activityDate?.toString() || "",
            activityTime: data?.activityTime || "",
            customDate: isoString || "",
            assignedToUserId: data?.assignedToUserId || getLocalValue(LoacalVariables.UserId),
            leadId: data?.leadId || "",
            customReminderTime: data.customReminderTime,
            notes: data?.notes || "",
            priority: data?.priority || "",
            queue: data?.queue || "",
            reminder: data?.reminder?.toString() || "",
            reminderSent: data?.reminderSent || false,
            taskType: data?.taskType || "",

        }
        if (data?.taskId) {
            const response: any = await callAPI("tasks", Method.PUT, request, data?.taskId);
            return response
        } else {
            const response: any = await callAPI("tasks", Method.POST, request);
            return response
        }

    }
    const handleCancelClick = () => {
        navigate(`/task/list`)
    }
    
    const leadSource = {
        url: "leads/search",
        page: 1,
        pageSize: 10000000,
        filter: [
        ],
        sort: [],
    };

    const actions: IHeaderListActions[] =
        [
            { type: 'button', text: 'Cancel', size: 'small', onClick: handleCancelClick, variant: 'outlined', color: 'primary' },
            { type: 'button', disabled:id!==undefined, text: 'Save & New', loading: loadingSaveAndNew, size: 'small', onClick: handleSubmit(handleDataSaveAndNew), buttonType: 'button', variant: 'outlined', color: 'primary' },
            { type: 'button', text: 'Save', loading: loading, size: 'small', onClick: handleSubmit(handleData), buttonType: 'submit', variant: 'outlined', color: 'primary' }
        ]
        const transFormLead=(data:any)=>{
            const optionLeads:Array<any>=[]
            if(data){
                data.map((item:any)=>{
                    optionLeads.push({label:`${item?.firstName} ${item?.lasttName || ""}`,value:item?.id})
                })
           
            }
            return optionLeads;
        }
    return (
        <Grid >
            <HeaderList title={!id?"Create New Task":"Update Task"} type="card" position="relative" actions={actions} isBackButton={true} url="/task/list" />
            {<Card>
                <CardContent>
                    <form>
                        <Grid container spacing={2} mt={0}>
                            <Grid item xs={12}>
                                <Typography fontWeight={"bold"} sx={{ fontSize: '.9rem' }}>Task Information</Typography>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <WSTextField
                                    label={"Task Name"}
                                    {...register("taskName")}
                                    id="taskName"
                                    name="taskName"
                                    control={control}
                                    rules={{ required: true }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <WSSelectField
                                    options={config.activitySourceConfig.staticOptionData}
                                    rules={{ required: true }}
                                    {...register("activityDate")}
                                    id="activityDate"
                                    isMobile={isMobile}
                                    control={control}
                                    defaultValue={0}
                                    onChange={handleActivityChange}
                                    label="Activity Date"
                                    name="activityDate"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <WSDateField dateFormat={"DD-MM-YYYY"}
                                    label={"Date"}
                                    disabled={activityDate !== 'custom'}
                                    id="customDate"
                                    defaultValue={dateFormat(activityDate, "DD-MM-YYYY")}
                                    setValue={setValue}
                                    name="customDate"
                                    control={control}
                                    rules={{ required: false }}

                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <WSTimePicker
                                    id="activityTime"
                                    name="activityTime"
                                    label={"Activity Time"}
                                    control={control}
                                    setValue={setValue}
                                    rules={{ required: true }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <WSSelectField
                                    options={config.taskTypeSourceConfig.staticOptionData}
                                    rules={{ required: true }}
                                    {...register("taskType")}
                                    id="taskType"
                                    isMobile={isMobile}
                                    control={control}
                                    defaultValue={"0"}
                                    label="Task type"
                                    name="taskType"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <WSSelectField
                                    options={config.prioritySourceConfig.staticOptionData}
                                    rules={{ required: true }}
                                    {...register("priority")}
                                    id="priority"
                                    isMobile={isMobile}
                                    control={control}
                                    defaultValue={"0"}
                                    label="Priority"
                                    name="priority"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <WSSelectField
                                    options={config.queueSourceConfig.staticOptionData}
                                    rules={{ required: true }}
                                    {...register("queue")}
                                    id="queue"
                                    isMobile={isMobile}
                                    control={control}
                                    defaultValue={"0"}
                                    label="Queue"
                                    name="queue"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                            <WSAutocompleteField
                                    source={leadSource}
                                    rules={{ required: true }}
                                    {...register("leadId")}
                                    id="leadId"
                                    transFormData={transFormLead}
                                    isMobile={isMobile}
                                    control={control}
                                    label="Lead"
                                    name="leadId"
                                />
                            </Grid>

                          
                            <Grid item xs={12} sm={6}>
                                <WSAutocompleteField
                                    source={source}
                                    rules={{ required: true }}
                                    {...register("assignedToUserId")}
                                    transFormData={transFormData}
                                    id="assignedToUserId"
                                    isMobile={isMobile}
                                    control={control}

                                    label="Assign to User"
                                    name="assignedToUserId"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <WSTextAreaField
                                    label={"Notes"}
                                    {...register("notes")}
                                    id="notes"
                                    name="notes"
                                    control={control}
                                    rules={{ required: true }}
                                    rows={2}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <WSSCheckBoxField
                                    label="Reminder Send"
                                    id="reminderSent"
                                    control={control}
                                    {...register("reminderSent")}
                                    rules={{ required: false }}
                                    name="reminderSent"

                                    onChange={handleIsReminderSend}
                                />

                                <WSHiddenField control={control} name="taskId" defaultValue={id} />
                            </Grid>
                            {isReminder && <><Grid item xs={12} sm={6}>
                                <WSTimePicker
                                    id="customReminderTime"
                                    name="customReminderTime"
                                    label={"Reminder Time"}
                                    control={control}
                                    setValue={setValue}
                                    rules={{ required: true }}
                                />
                            </Grid>
                                <Grid item xs={12} sm={6}>
                                    <WSSelectField
                                        options={config.reminderSourceConfig.staticOptionData}
                                        rules={{ required: true }}
                                        {...register("reminder")}
                                        id="reminder"
                                        isMobile={isMobile}
                                        control={control}
                                        defaultValue={0}
                                        label="Reminder"
                                        name="reminder"
                                    />

                                </Grid></>}
                        </Grid >
                    </form>
                </CardContent>
            </Card>

            }
        </Grid >
    );
};

